export const SET_ROLES_AND_BUSINESS = 'SET_ROLES_AND_BUSINESS'
export const ON_ROLE_CHANGE = 'ON_ROLE_CHANGE'
export const ON_BUSINESS_CHANGE = 'ON_BUSINESS_CHANGE'
export const SET_PLAYER_TYPE_LIST = 'SET_PLAYER_TYPE_LIST'
export const SET_USERS_LIST = 'SET_USERS_LIST'
export const GET_PLAYER_TYPE_LIST = 'GET_PLAYER_TYPE_LIST'
export const GET_ROLES_AND_BUSINESS = 'GET_ROLES_AND_BUSINESS'
export const GET_USERS_LIST = 'GET_USERS_LIST'
export const SET_COACH_LIST = 'SET_COACH_LIST'
export const ON_RANGE_CHANGE = 'ON_RANGE_CHANGE'
export const SET_HEADER_TITLE = 'SET_HEADER_TITLE'
export const ON_USERNAME_CHANGE = 'ON_USERNAME_CHANGE'
export const ON_FIRSTNAME_CHANGE = 'ON_FIRSTNAME_CHANGE'
export const ON_LAST_NAME_CHANGE = 'ON_LAST_NAME_CHANGE'
export const ON_ALIAS_CHANGE = 'ON_ALIAS_CHANGE'
export const ON_PLAYER_TYPE_CHANGE = 'ON_PLAYER_TYPE_CHANGE'
export const ON_COACH_CHANGE = 'ON_COACH_CHANGE'
export const ON_OFFSET_CHANGE = 'ON_OFFSET_CHANGE'
export const SET_OFFSET = 'SET_OFFSET'
export const GET_MULTIPLE_REPORT_CARD_DETAILS = 'GET_MULTIPLE_REPORT_CARD_DETAILS'
export const GET_SINGLE_REPORT_CARD_DETAILS = 'GET_SINGLE_REPORT_CARD_DETAILS'
export const GET_MY_STATISTICS_DETAILS = 'GET_MY_STATISTICS_DETAILS'
export const SET_MY_STATISTICS_DETAILS = 'SET_MY_STATISTICS_DETAILS'
export const SET_MY_STAT_TOP_HANDS = 'SET_MY_STAT_TOP_HANDS'
export const SET_TOP_HANDS = 'SET_TOP_HANDS'
export const SET_REPORT_CARD_DETAILS = 'SET_REPORT_CARD_DETAILS'
export const GET_ON_LOAD_REPORT_CARD_DETAILS = 'GET_ON_LOAD_REPORT_CARD_DETAILS'
export const SET_LEVEL_INFO = 'SET_LEVEL_INFO'
export const SET_REPORT_CARD_SETTING = 'SET_REPORT_CARD_SETTING'
export const SET_SINGLE_REPORT_CARD_DETAILS = 'SET_SINGLE_REPORT_CARD_DETAILS'
export const SET_LOADING = 'SET_LOADING'
export const SET_GAME_TYPE = 'SET_GAME_TYPE'
export const SET_RANGE = 'SET_RANGE'
export const SET_LEVEL = 'SET_LEVEL'
export const SET_TYPE = 'SET_TYPE'
export const GET_MISSIONS = 'GET_MISSIONS'
export const SET_MISSIONS = 'SET_MISSIONS'
export const USER_LOGOUT = 'USER_LOGOUT'
export const ON_PAGINATE = 'ON_PAGINATE';
export const APPUSER_ON_SORT = 'ON_SORT';
export const SET_MY_STAT_SETTINGS = 'SET_MY_STAT_SETTINGS';
export const GET_PLAYER_LEVELS = 'GET_PLAYER_LEVELS';
export const SET_PLAYER_LEVELS = 'SET_PLAYER_LEVELS';
export const GET_PLAYER_GAME_SUB_TYPES = 'GET_PLAYER_GAME_SUB_TYPES';
export const SET_PLAYER_GAME_SUB_TYPES = 'SET_PLAYER_GAME_SUB_TYPES';
export const GET_PLAYER_HIT_TYPES = 'GET_PLAYER_HIT_TYPES';
export const SET_PLAYER_HIT_TYPES = 'SET_PLAYER_HIT_TYPES';
export const GET_RANGEBAR_VALUE = 'GET_RANGEBAR_VALUE';
export const SET_RANGEBAR_VALUE = 'SET_RANGEBAR_VALUE';
export const SET_PROMOTIONAL_CONTENT = 'SET_PROMOTIONAL_CONTENT';
export const TOGGLE_TOURNAMENT_HISTORY_DETAILS = 'TOGGLE_TOURNAMENT_HISTORY_DETAILS';
export const TOGGLE_TOURNAMENT_HISTORY_FULL_SCREEN = 'TOGGLE_TOURNAMENT_HISTORY_FULL_SCREEN';
export const SET_TOURNY_FILTER = 'SET_TOURNY_FILTER';
export const SET_HAND_HISTORY_FILTER = "SET_HAND_HISTORY_FILTER";
export const SET_SELECTED_HAND_LIST = "SET_SELECTED_HAND_LIST";
export const SET_HAND_HISTORY_PREV_FILTER = "SET_HAND_HISTORY_PREV_FILTER";
export const LOAD_BRAND_AUTH_CONFIG = "LOAD_BRAND_LOGIN_CONFIG";
export const LOAD_QUIZ_DETAILS = "LOAD_QUIZ_DETAILS";
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const LOAD_QUIZ_TYPE_DETAILS = "LOAD_QUIZ_TYPE_DETAILS";

// export cons



/** WEBPACK FOOTER **
 ** ./src/store/actions/actionTypes.js
 **/